var _path, _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0H33C49.5685 0 63 13.4315 63 30C63 46.5685 49.5685 60 33 60H30C13.4315 60 0 46.5685 0 30Z",
    fill: "#65D3E9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 54,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 54,
    height: 49,
    rx: 24.5,
    stroke: "#FAFAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5188_15068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6 46.4331H21.4C18.15 46.4331 15.6666 45.2497 14.4 43.1164C13.15 40.9831 13.3166 38.2331 14.9 35.3831L25 17.2164C26.6666 14.2164 28.9667 12.5664 31.5 12.5664C34.0333 12.5664 36.3333 14.2164 38 17.2164L48.1 35.3997C49.6833 38.2497 49.8667 40.9831 48.6 43.1331C47.3333 45.2497 44.85 46.4331 41.6 46.4331ZM31.5 15.0664C29.9333 15.0664 28.4 16.2664 27.1833 18.4331L17.1 36.6164C15.9666 38.6497 15.7833 40.5164 16.5666 41.8664C17.35 43.2164 19.0833 43.9497 21.4166 43.9497H41.6167C43.95 43.9497 45.6667 43.2164 46.4667 41.8664C47.2667 40.5164 47.0667 38.6664 45.9333 36.6164L35.8167 18.4331C34.6 16.2664 33.0667 15.0664 31.5 15.0664Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 34.0833C30.8167 34.0833 30.25 33.5167 30.25 32.8333V24.5C30.25 23.8167 30.8167 23.25 31.5 23.25C32.1833 23.25 32.75 23.8167 32.75 24.5V32.8333C32.75 33.5167 32.1833 34.0833 31.5 34.0833Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5002 39.4996C31.4002 39.4996 31.2835 39.4829 31.1668 39.4663C31.0668 39.4496 30.9668 39.4163 30.8668 39.3663C30.7668 39.3329 30.6668 39.2829 30.5668 39.2163C30.4835 39.1496 30.4002 39.0829 30.3168 39.0163C30.0168 38.6996 29.8335 38.2663 29.8335 37.8329C29.8335 37.3996 30.0168 36.9663 30.3168 36.6496C30.4002 36.5829 30.4835 36.5163 30.5668 36.4496C30.6668 36.3829 30.7668 36.3329 30.8668 36.2996C30.9668 36.2496 31.0668 36.2163 31.1668 36.1996C31.3835 36.1496 31.6168 36.1496 31.8168 36.1996C31.9335 36.2163 32.0335 36.2496 32.1335 36.2996C32.2335 36.3329 32.3335 36.3829 32.4335 36.4496C32.5168 36.5163 32.6002 36.5829 32.6835 36.6496C32.9835 36.9663 33.1668 37.3996 33.1668 37.8329C33.1668 38.2663 32.9835 38.6996 32.6835 39.0163C32.6002 39.0829 32.5168 39.1496 32.4335 39.2163C32.3335 39.2829 32.2335 39.3329 32.1335 39.3663C32.0335 39.4163 31.9335 39.4496 31.8168 39.4663C31.7168 39.4829 31.6002 39.4996 31.5002 39.4996Z",
    fill: "#0B4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5188_15068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(11.5 9.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.5e8397991266afb73be4d1d75a3f5a7b.svg";
export { ForwardRef as ReactComponent };